/** Filtri da inviare al BE per il testo digitato nel campo di ricerca della finestra dei seriali. */
export interface SerialSearchFilters {
  /** Ricerca "contiene" (senza distinzione tra maiuscole e minuscole). */
  serial_number?: string;
  /** Elenco esatto, usato solo se nel campo è stato incollato un elenco separato da virgole. */
  serial_numbers?: string[];
}

export function buildSerialSearch(text: string | null | undefined): SerialSearchFilters {
  const value = (text ?? '').trim();
  if (!value) return {};
  if (value.includes(',')) {
    const list = value
      .split(',')
      .map(s => s.trim())
      .filter(s => !!s);
    return list.length > 0 ? { serial_numbers: list } : {};
  }
  return { serial_number: value };
}
